import { render } from "./TransplantSectionDetails.vue?vue&type=template&id=5526cb70&scoped=true"
import script from "./TransplantSectionDetails.vue?vue&type=script&lang=js"
export * from "./TransplantSectionDetails.vue?vue&type=script&lang=js"

import "./TransplantSectionDetails.vue?vue&type=style&index=0&id=5526cb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5526cb70"],['__file',"src/components/TransplantSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5526cb70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5526cb70', __exports__)) {
    api.reload('5526cb70', __exports__)
  }
  
  module.hot.accept("./TransplantSectionDetails.vue?vue&type=template&id=5526cb70&scoped=true", () => {
    api.rerender('5526cb70', render)
  })

}


export default __exports__